export { nationalityToCountry, countryToNationality, getAllNationalityMappings, isValidNationality, } from "./core";
//# sourceMappingURL=index.js.map